const SecondaryButton = ({
  onClick,
  title = '',
}: {
  onClick: any;
  title?: string;
}) => {
  return (
    <button
      onClick={onClick}
      className='m-auto mr-3 rounded-full border-[2px] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 hover:border-black hover:bg-black hover:text-white'
    >
      {title}
    </button>
  );
};

export default SecondaryButton;
